import { render } from "./LeaveTypeSetting.vue?vue&type=template&id=4f359e5f&scoped=true"
import script from "./LeaveTypeSetting.vue?vue&type=script&lang=js"
export * from "./LeaveTypeSetting.vue?vue&type=script&lang=js"

import "./LeaveTypeSetting.vue?vue&type=style&index=0&id=4f359e5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f359e5f"]])

export default __exports__